/**
 * Authentication Storage Helper
 */

const AUTH_KEYS = {
    USER_ID: 'User_Id',
    ACCESS_TOKEN: 'access_token',
    USER_INFO: 'user_info',
    USER_EMAIL: 'user_email',
    USER_FULLNAME: 'user_fullname',
    USER_ROLE: 'user_role',
    LOGIN_TIME: 'login_time',
    TOKEN_EXPIRY: 'token_expiry'
};

export const authStorage = {
    saveLoginData(loginData) {
        try {
            console.log('💾 Saving login data...', loginData);
            
            const userId = loginData.userId || loginData.user_id || loginData.id || (loginData.user && loginData.user.id);
            if (userId) {
                localStorage.setItem(AUTH_KEYS.USER_ID, userId.toString());
                console.log('✅ Saved userId:', userId);
            }

            const accessToken = loginData.access_token || loginData.accessToken || loginData.token;
            if (accessToken) {
                localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, accessToken);
                console.log('✅ Saved token');
            }

            const userData = loginData.user || loginData.data || loginData;
            if (userData && typeof userData === 'object') {
                localStorage.setItem(AUTH_KEYS.USER_INFO, JSON.stringify(userData));
                console.log('✅ Saved user_info');

                const email = userData.email || userData.Email;
                if (email) {
                    localStorage.setItem(AUTH_KEYS.USER_EMAIL, email);
                }

                const fullname = userData.fullname || userData.full_name || userData.name || userData.username;
                if (fullname) {
                    localStorage.setItem(AUTH_KEYS.USER_FULLNAME, fullname);
                }

                const role = userData.role || userData.user_role || userData.type;
                if (role) {
                    localStorage.setItem(AUTH_KEYS.USER_ROLE, role);
                }
            }

            localStorage.setItem(AUTH_KEYS.LOGIN_TIME, new Date().toISOString());

            const tokenExpiry = loginData.token_expiry || loginData.tokenExpiry || loginData.expires_at;
            if (tokenExpiry) {
                localStorage.setItem(AUTH_KEYS.TOKEN_EXPIRY, tokenExpiry);
            }

            console.log('✅ All data saved successfully');
            return true;
        } catch (error) {
            console.error('❌ Save error:', error);
            return false;
        }
    },

    getUserId() {
        return localStorage.getItem(AUTH_KEYS.USER_ID);
    },

    getAccessToken() {
        return localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN);
    },

    getUserInfo() {
        try {
            const userInfo = localStorage.getItem(AUTH_KEYS.USER_INFO);
            return userInfo ? JSON.parse(userInfo) : null;
        } catch (error) {
            return null;
        }
    },

    getUserEmail() {
        return localStorage.getItem(AUTH_KEYS.USER_EMAIL);
    },

    getUserFullname() {
        return localStorage.getItem(AUTH_KEYS.USER_FULLNAME);
    },

    getUserRole() {
        return localStorage.getItem(AUTH_KEYS.USER_ROLE);
    },

    getLoginTime() {
        return localStorage.getItem(AUTH_KEYS.LOGIN_TIME);
    },

    getTokenExpiry() {
        return localStorage.getItem(AUTH_KEYS.TOKEN_EXPIRY);
    },

    isAuthenticated() {
        const userId = this.getUserId();
        const token = this.getAccessToken();
        return !!(userId && token);
    },

    isTokenExpired() {
        const expiry = this.getTokenExpiry();
        if (!expiry) return false;

        try {
            const expiryTime = new Date(expiry).getTime();
            const currentTime = new Date().getTime();
            return currentTime >= expiryTime;
        } catch (error) {
            return false;
        }
    },

    clearAuth() {
        try {
            Object.values(AUTH_KEYS).forEach(key => {
                localStorage.removeItem(key);
            });
            return true;
        } catch (error) {
            return false;
        }
    },

    getAllAuthData() {
        return {
            userId: this.getUserId(),
            accessToken: this.getAccessToken(),
            userInfo: this.getUserInfo(),
            email: this.getUserEmail(),
            fullname: this.getUserFullname(),
            role: this.getUserRole(),
            loginTime: this.getLoginTime(),
            tokenExpiry: this.getTokenExpiry(),
            isAuthenticated: this.isAuthenticated(),
            isTokenExpired: this.isTokenExpired()
        };
    }
};
